import DismissibleSuccessBanner from "../../../containers/customerItems/DismissibleSuccessBanner";
import DismissibleWarningBanner from "../../../containers/customerItems/DismissibleWarningBanner";
import DismissibleErrorBanner from "../../../containers/customerItems/DismissibleErrorBanner";

const Banners = () => (
  <>
    <DismissibleSuccessBanner />
    <DismissibleWarningBanner />
    <DismissibleErrorBanner />
  </>
);

export default Banners;
